import React from 'react';

const Header = () => {
    return (
        <div>
            <img src={require('./../images/ISS_emblem.png')} alt='ISS LOGO' width='200px' height='200px'></img>
            <p>Want to know where the ISS is right now??</p>
        </div>
    )
}

export default Header;
